import { RiShareBoxFill } from 'react-icons/ri'
import { isValidUrl, sanitizeURL } from 'utils'
import { GTextWithExternalLinkProps } from './types'

export const GTextWithExternalLink = ({
	text,
	className = '',
	showIcon = true
}: GTextWithExternalLinkProps) => {
	if (!text) return null

	const displayText = sanitizeURL(text)
	const shouldShowIcon = showIcon && isValidUrl(text)

	return (
		<span className="inline-flex items-center">
			<span className={className}>{displayText}</span>
			{shouldShowIcon && (
				<a
					href={`//${text}`}
					target="_blank"
					rel="noopener noreferrer"
					className="pl-2 text-brand flex-shrink-0"
				>
					<RiShareBoxFill />
				</a>
			)}
		</span>
	)
}

